import React, { useState } from 'react';
import { X } from 'lucide-react';
import { login, register, oauthLogin } from '../auth';

export default function LoginModal({ onClose, onAuth, onPolicy, onOffer, onForgotPassword = () => {} }) {
  const [mode, setMode] = useState('login');
  const [email, setEmail] = useState('');
  const [pass, setPass] = useState('');
  const [error, setError] = useState('');
  const [emailValid, setEmailValid] = useState(true);
  const [notifyOnPlanReady, setNotifyOnPlanReady] = useState(false);

  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  const submit = async () => {
    if (!emailRegex.test(email)) {
      setError('Некорректный e-mail');
      setEmailValid(false);
      return;
    }
    let user = null;
    if (mode === 'login') {
      const result = await login(email, pass);
      if (!result || result.error) {
        if (result && result.error === 'locked') {
          const minutes = Math.max(1, Number(result.minutesLeft || 0));
          setError(`Вы исчерпали все попытки входа, пожалуйста подождите ${minutes} минут или нажмите "Забыли пароль?"`);
        } else {
          setError('Неверные данные');
        }
        return;
      }
      user = result.user;
    } else {
      const result = await register(email, pass, { notifyOnPlanReady });
      if (result.error) {
        setError(
          result.error === 409
            ? 'Пользователь уже существует'
            : result.error === 400
            ? 'Некорректный e-mail'
            : 'Что-то пошло не так, попробуйте позже'
        );
        return;
      }
      user = result.user;
    }
    onAuth(user);
    onClose();
  };

  const gos = async () => {
    const user = await oauthLogin();
    if (!user) return;
    onAuth(user);
    onClose();
  };

  const handleForgot = () => {
    setMode('login');
    setError('');
    onForgotPassword();
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 p-4" role="dialog" aria-modal>
      <div className="w-full max-w-sm rounded-2xl bg-white p-6 shadow-xl">
        <div className="flex items-start justify-between mb-4">
          <h2 className="text-xl font-semibold">
            {mode === 'login' ? 'Вход' : 'Регистрация'}
          </h2>
          <button onClick={onClose} className="text-slate-400 hover:text-slate-600">
            <X className="h-5 w-5" />
          </button>
        </div>
        <div className="space-y-3">
          <input
            value={email}
            onChange={e => {
              setEmail(e.target.value);
              setEmailValid(emailRegex.test(e.target.value));
            }}
            placeholder="E-mail"
            className={`w-full rounded-lg border px-3 py-2 text-[15px] ${
              email && !emailValid ? 'border-red-500' : ''
            }`}
          />
          <input
            type="password"
            value={pass}
            onChange={e => setPass(e.target.value)}
            placeholder="Пароль"
            className="w-full rounded-lg border px-3 py-2 text-[15px]"
          />
        </div>
        {mode === 'login' && (
          <div className="mt-1 text-right text-sm">
            <button type="button" className="text-blue-600 hover:text-blue-700" onClick={handleForgot}>
              Забыли пароль?
            </button>
          </div>
        )}
        {error && <div className="mt-2 text-sm text-red-600">{error}</div>}
        {mode === 'register' && (
          <label className="mt-3 flex items-start gap-2 text-sm text-slate-600">
            <input
              type="checkbox"
              checked={notifyOnPlanReady}
              onChange={(e) => setNotifyOnPlanReady(e.target.checked)}
              className="mt-0.5 h-4 w-4"
            />
            <span>Отправлять уведомление о завершении генерации (не обязательно)</span>
          </label>
        )}
        <button
          onClick={submit}
          className="mt-4 inline-flex w-full h-11 items-center justify-center rounded-lg bg-blue-600 px-5 text-white font-semibold shadow hover:bg-blue-700"
        >
          {mode === 'login' ? 'Войти' : 'Зарегистрироваться'}
        </button>
        <button
          onClick={gos}
          className="mt-3 inline-flex w-full h-11 items-center justify-center rounded-lg border px-5 text-sm"
          style={{ display: 'none' }}
        >
          Войти через госуслуги
        </button>
        <div className="mt-3 text-center text-sm">
          {mode === 'login' ? (
            <button className="underline" onClick={() => {setMode('register'); setError('');}}>
              Зарегистрироваться
            </button>
          ) : (
            <button className="underline" onClick={() => {setMode('login'); setError('');}}>
              Уже есть аккаунт? Войти
            </button>
          )}
        </div>
        {mode === 'register' && (
          <div className="mt-3 text-center text-[12px] text-slate-500">
            Нажимая «Зарегистрироваться», вы соглашаетесь с
            <button onClick={onPolicy} className="underline ml-1">Политикой конфиденциальности</button>
            {" и "}
            <button onClick={onOffer} className="underline">Офертой</button>
          </div>
        )}
      </div>
    </div>
  );
}
